import { useEffect, useState } from "react";
import { findActiveHeadingId } from "@/lib/ActiveHeading";

export function useActiveHeadingId(
  ids: readonly string[],
  threshold = 112,
): string | null {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    let frameId: number | null = null;

    const updateActiveId = () => {
      const headings = ids.flatMap((id) => {
        const element = document.getElementById(id);
        return element
          ? [{ id, top: element.getBoundingClientRect().top }]
          : [];
      });
      setActiveId(findActiveHeadingId(headings, threshold));
    };

    const handleScrollOrResize = () => {
      if (frameId !== null) {
        return;
      }
      frameId = requestAnimationFrame(() => {
        frameId = null;
        updateActiveId();
      });
    };

    updateActiveId();
    window.addEventListener("scroll", handleScrollOrResize, {
      passive: true,
    });
    window.addEventListener("resize", handleScrollOrResize, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScrollOrResize);
      window.removeEventListener("resize", handleScrollOrResize);
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }
    };
  }, [ids, threshold]);

  return activeId;
}
